import React from 'react';

import CharacterAssetCardContainer from './components/CharacterAssetCardContainer';



const CharactersDialogAsset = (props) => {
  const {
    scenario,
    game,
    dialog,
    gameWithFormattedTags,
    isRestartGame,
    setSubscriptionModalState,
    setIsSignUpModalOpen,
    setIsEmailConfirmationModalOpen,
    isMobileView = false,
  } = props;


  const handleSubscriptionModalOpen = () => {
    setSubscriptionModalState({
      isOpen: true,
      renderedForReason: 'dialog_character_info_click'
    });
  };

  return (
    <CharacterAssetCardContainer
      analyticsData={{
        config_name: scenario?.name,
        scenario_name: game?.name,
        dialogId: dialog?.id
      }}
      game={gameWithFormattedTags}
      isRestartGame={isRestartGame}
      characters={scenario?.characters || []}
      setIsSubscriptionModalOpen={handleSubscriptionModalOpen}
      setIsSignUpModalOpen={setIsSignUpModalOpen}
      setIsEmailConfirmationModalOpen={setIsEmailConfirmationModalOpen}
      isMobileView={isMobileView}
      isPublic={game?.isPublic}
      scenario={scenario}
    />
  );
};

export default CharactersDialogAsset;
